export * from './team-logo';